import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import CampaignIdParams from './CampaignIdParams';

export type TagsInputValue = any[]

const mapStateToProps = (state, { t }) => {
  const campaignIdParams: TagsInputValue = state.trackerSettings.app.settings
    .attributes.campaign_id_params || [];
  const globalCampaignIdParams: TagsInputValue = (
    state.trackerSettings.global.settings
      .attributes.campaign_id_params || []
  )
    .map(
      element => ({
        value: element,
        disabled: true,
        tooltip: {
          content: t('apps.details.settings.globals.tooltip.content'),
        },
      }),
    );

  const globalAndAppTrackerSettings = [
    ...globalCampaignIdParams,
    ...campaignIdParams,
  ];

  return {
    globalAndAppTrackerSettings,
  };
};

export default withTranslation(['administration'])(connect(mapStateToProps, null)(CampaignIdParams));
